import { Col, Row, Table, Typography } from 'antd';
import { localize } from 'mixins/helpers';
import { PrintIcon } from 'mixins/icons/booking-queue.icons';
import CmsTable from 'mixins/ui/cms-table';
import PrintForm2 from 'mixins/ui/print-form-2';
import React from 'react';
import { urlPrint } from '../actions';
import {
    columns,
    IDENTIFIER_TYPE_MAP,
    ndsRevenueColumns,
    paymentColumns,
    TAXPAYER_TYPE_PREFIX,
} from '../constants';
import { GetResultsTableProps } from '../find-taxpayer-service.type';

export function GetResultsTable({
    noResNumber,
    item,
    translations,
    type,
    values,
    lang,
    paymentData,
}: GetResultsTableProps) {
    const identifier = IDENTIFIER_TYPE_MAP[type];

    return (
        <div className="results-container">
            <CmsTable
                noResNumber={noResNumber}
                resultCard={item?.name}
                columns={columns(translations, lang, type, item?.rows.length)}
                dataSource={item?.rows || []}
                size="large"
                translations={translations}
                type="default"
                pagination={false}
            >
                {['UL', 'IP'].includes(type) && item.rows.length > 1 ? null : (
                    <>
                        <Col xs={type === 'LZCHP' ? 24 : 13}>
                            <Typography.Paragraph>
                                {localize(identifier, translations)}
                            </Typography.Paragraph>
                            <Typography.Paragraph
                                style={{
                                    fontSize: type === 'LZCHP' && 20,
                                }}
                            >
                                {item?.iinBin}
                            </Typography.Paragraph>
                        </Col>

                        {type !== 'LZCHP' && (
                            <Col xs={11}>
                                <Typography.Paragraph>
                                    {localize('type', translations)}
                                </Typography.Paragraph>
                                <Typography.Paragraph>
                                    {localize(`${TAXPAYER_TYPE_PREFIX}-${type}`, translations)}
                                </Typography.Paragraph>
                            </Col>
                        )}
                    </>
                )}
            </CmsTable>

            {/* {type === 'UL' && item?.ulTaxInfo?.length > 0 && (
                <TaxPeriodsTable
                    translations={translations}
                    ulTaxInfo={item.ulTaxInfo}
                />
            )} */}

            {type === 'UL' && paymentData && (
                <>
                    <Typography.Title
                        level={4}
                        style={{
                            marginTop: 40,
                        }}
                    >
                        {localize('find-taxpayer-service-tax-payment-info', translations)}
                        <br />
                        {localize('find-taxpayer-service-in-tenge', translations)}
                    </Typography.Title>

                    <Typography.Paragraph>
                        {localize('find-taxpayer-service-tax-payment-info-description', translations)}
                    </Typography.Paragraph>

                    <Table
                        dataSource={[
                            {
                                type: 'tax',
                                ...paymentData.taxRevenue.overall,
                            },
                        ]}
                        columns={paymentColumns(translations)}
                        scroll={{
                            x: true,
                        }}
                        pagination={false}
                    />

                    <Table
                        dataSource={[
                            {
                                type: 'tax',
                                ...paymentData.ndsRevenue.tax,
                            },
                        ]}
                        columns={ndsRevenueColumns(translations)}
                        scroll={{
                            x: true,
                        }}
                        pagination={false}
                        style={{
                            marginTop: 20,
                        }}
                    />
                </>
            )}

            {item && (
                <Row>
                    <PrintForm2
                        apiUrl={
                            type === 'FL'
                                ? urlPrint + '?token=4f9fc460-05fb-438c-9d99-1dcb52e95503'
                                : urlPrint
                        }
                        isPost
                        params={{
                            iinBin: values.iinBin,
                            firstName: values.firstName,
                            lastName: values.lastName,
                            name: values.organizationName,
                            type: values.type,
                        }}
                        icon={<PrintIcon />}
                        translations={translations}
                    />
                </Row>
            )}
        </div>
    );
}
